import { call, select } from 'redux-saga/effects';

import config from '@epi-config';
import { downloadFileAuthenticated } from '@epi-helpers/DownloadFileHelper';
import { getCustomerNumber } from '@epi-selectors/api';

import { Authorize } from '../constants/authorize';

import { getRequest, postRequest } from './ApiRepository';

export function* getCompanyAccounts() {
  return yield call(
    getRequest,
    `${config.apiHost}/api/company-accounts`,
    Authorize.Always
  );
}

export function* getCompanyMetadata() {
  return yield call(
    getRequest,
    `${config.apiHost}/api/company-metadata`,
    Authorize.Always
  );
}

export function* depositCompanyAccount(payload) {
  const customerNumber = yield select(getCustomerNumber);

  return yield call(
    postRequest,
    `${config.apiHost}/api/deposit-orders`,
    Authorize.Always,
    payload
  );
}

export function getReceiptForDepositOrder(depositId) {
  return downloadFileAuthenticated(
    `${config.apiHost}/api/company-accounts/deposits/${depositId}/receipt`,
    'receipt.pdf'
  );
}

export function getReceiptForTransaction(transactionId) {
  return downloadFileAuthenticated(
    `${config.apiHost}/api/company-accounts/transactions/${transactionId}/receipt`,
    'receipt.pdf'
  );
}
